import { Outlet } from "react-router-dom"

const HRParentPage = () => {
    return (
        <Outlet />
    )
}

export default HRParentPage;
